/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */

import pixosEngine from "pixos-engine";
let Modules = pixosEngine['pixos-engine'].Modules;

let Resources = Modules.utils.resources;
let Spurt = Modules.sprites.effects.Spurt;
export default class LavaSpurt extends Spurt {
  constructor(engine) {
    // Initialize Sprite
    super(engine);
    this.src = Resources.artResourceUrl("tileset.png");
    this.sheetSize = [512, 512];
    this.tileSize = [16, 16];
    // Frames
    this.frames = {
      up: [
        [0, 416],
        [16, 416],
        [32, 416],
        [48, 416],
        [64, 416],
        [80, 416],
      ],
    };
  }
}
